// userThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "antd";
import { Api_Caller } from "../../utils/Api";
import { logoutAndResetStore } from "../slices/authSlice";

export const loginThunk = createAsyncThunk(
  "loginSlice/loginThunk",
  async ({ mobile, password }, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ALL}/${Api_Caller.auth}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            mobile: mobile,
            password: password,
          }),
        },
      );
      const data = await response.json();
      if (!response.ok) {
        const errorMessage =
          data?.message || data?.error || "Invalid mobile number or password";

        message.error(errorMessage);
        return rejectWithValue(errorMessage);
      }
      if (data?.data?.role?.toUpperCase() !== "ADMIN") {
        message.error("You are not authorized to access this dashboard.");
        return rejectWithValue("Unauthorized role");
      }

      message.success("Login Successfully!");
      return data?.data;
    } catch (error) {
      message.error(error.message || "Something went wrong");
      return rejectWithValue(error.message);
    }
  },
);

export const logoutAdmin = createAsyncThunk(
  "auth/logoutAdmin",
  async (_, { getState, dispatch, rejectWithValue }) => {
    const state = getState();

    // Same variable name as login slice
    const accessToken = state.auth.accessToken;

    if (!accessToken) {
      dispatch(logoutAndResetStore());
      return rejectWithValue("Access token not found");
    }

    try {
      const response = await fetch(process.env.REACT_APP_USER, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          query: `
            mutation {
              logoutCurrentSession
            }
          `,
        }),
      });

      if (response.status === 401 || response.status === 410) {
        dispatch(logoutAndResetStore());
        message.error("Session expired. Please login again.");
        return rejectWithValue("Unauthorized");
      }

      const result = await response.json();

      if (result.errors) {
        message.error(result.errors[0].message);
        return rejectWithValue(result.errors[0].message);
      }

      dispatch(logoutAndResetStore());

      message.success("Logout Successfully!");

      return result.data;
    } catch (error) {
      dispatch(logoutAndResetStore());
      message.error(error.message || "Logout failed");
      return rejectWithValue(error.message);
    }
  },
);
